export default "__VITE_ASSET__65e3a014__"